import { RoutesConfig } from 'navigation/routes';
import { isBuyerQuotationFlowPath } from 'navigation/helpers';
import { AppMode } from 'store/Common/reducers/common';
import { CompanyRole } from 'types/Company.types';

export const getLogoNavigationDestinationBasedOnAppMode = (
  appMode: AppMode,
  pathname?: string
) => {
  switch (appMode) {
    case AppMode.EXTERNAL:
      return RoutesConfig.Configure.fullPath;
    case AppMode.DEALER_PANEL:
      return RoutesConfig.Suppliers.fullPath;
    case AppMode.BUYER:
      return isBuyerQuotationFlowPath(pathname)
        ? RoutesConfig.BuyerQuotations.fullPath
        : RoutesConfig.BuyerOrders.fullPath;
    case AppMode.SUPPLIER:
      return RoutesConfig.SupplierOrders.fullPath;
  }
};

// Returns the app mode the user is allowed to stay in for a given company role.
// Companies with the BOTH role keep the current mode, single role companies force their own mode.
export const getAppModeBasedOnCompanyRole = (
  role: CompanyRole | undefined,
  currentAppMode: AppMode
): AppMode => {
  // EXTERNAL and DEALER_PANEL are not tied to the company role
  if (
    currentAppMode === AppMode.EXTERNAL ||
    currentAppMode === AppMode.DEALER_PANEL
  ) {
    return currentAppMode;
  }
  switch (role) {
    case CompanyRole.SELLER:
      return AppMode.SUPPLIER;
    case CompanyRole.BUYER:
      return AppMode.BUYER;
    default:
      return currentAppMode;
  }
};
